<template>
  <vs-popup class="vs-con-loading__container"
            id="popup"
            title="DOWNLOAD INVENTORY LOG"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(downloadReportDocument)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="from" name="from" rules="required" v-slot="{ errors }">
                <small class="label">From</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="from"
                            placeholder="Choose Date"
                />
                <flat-pickr
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="from"
                            placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="to" name="to" rules="required" v-slot="{ errors }">
                <small class="label">To</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="to"
                            placeholder="Choose Date"
                />
                <flat-pickr
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="to"
                            placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const ActivityRepository = RepositoryFactory.get('activity')
import 'flatpickr/dist/plugins/monthSelect/style.css'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: "DownloadInventoryLogPopUp",
  data () {
    return {
      open: false,
      inventory_id: '',
      activity_type: '',
      to: '',
      from: '',
      timezone: 'Europe/London',
    }
  },
  components: {
    flatPickr
  },
  mixins : [ErrorMessages],
  methods:{
    openPopup(id, type) {
      this.open = true
      this.activity_type = type
      this.inventory_id = id
    },
    async downloadReportDocument(){
      this.$vs.loading()
      try {
        const response = await ActivityRepository.downloadActivityLogReport(
          this.activity_type, this.inventory_id, `from=${this.from}&to=${this.to}&timezone=${this.timezone}`
          )
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `Inventory Item Change Log (${this.from} - ${this.to}) ${this.activity_type}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    }
  },
}
</script>

<style scoped>

</style>
